import styled from 'styled-components';
import mask from '../../assets/images/faq/fag_bg_mask.svg';
import bg from '../../assets/images/faq/faq_bg.jpg';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	padding: 54px 40px 60px;

	transition: opacity 0.3s ease;

	&.faq-enter {
		opacity: 0;
	}

	&.faq-enter-active,
	&.faq-enter-done,
	&.faq-exit {
		opacity: 1;
	}

	&.faq-exit-active {
		opacity: 0;
	}
`;

const StyledTextContainer = styled.div<{ $button?: boolean }>`
	max-width: 740px;
	max-height: ${(props) => (props.$button ? '567px' : '687px')};
	display: flex;
	overflow: scroll;
	flex-direction: column;
	gap: 60px;
	margin-top: 53px;

	&::-webkit-scrollbar {
		display: none;
	}
`;

const StyledBackgroundImage = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	width: 800px;
	height: 100%;
	mask-image: url(${mask});
	mask-position: center;
	mask-repeat: no-repeat;
	mask-size: cover;
	-webkit-mask-image: url(${mask});
	-webkit-mask-position: center;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-size: cover;
	background-image: url(${bg});
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
`;

const StyledMapButton = styled.div`
	position: absolute;
	bottom: 60px;
	left: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;
	width: 218px;
	height: 60px;
	background-color: #2d70da;
	border-radius: 10px;
	transition: background-color 0.3s ease;
	cursor: pointer;

	${TextLabel} {
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;
		transition: color 0.3s ease;
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		${TextLabel} {
			color: #000000;
		}

		img {
			filter: invert(100%);
		}
	}
`;

export {
	StyledBackgroundImage,
	StyledContainer,
	StyledMapButton,
	StyledTextContainer,
};
